import React from 'react';

interface KpiCardProps {
  label: string;
  value: string | number;
  sub?: string;
  borderColor: string;
  mono?: boolean; // use DM Mono for value (default true)
}

export function KpiCard({ label, value, sub, borderColor, mono = true }: KpiCardProps) {
  return (
    <div
      className="bg-surface rounded-card p-4 shadow-card flex flex-col gap-1"
      style={{ borderTop: `2px solid ${borderColor}` }}
    >
      <p
        className="text-[10px] font-semibold uppercase tracking-[0.06em] text-muted"
      >
        {label}
      </p>
      <p
        className="text-[24px] font-medium text-ink leading-none"
        style={mono ? { fontFamily: '"DM Mono", monospace' } : { fontFamily: '"Plus Jakarta Sans", system-ui' }}
      >
        {value}
      </p>
      {sub && (
        <p className="text-[11px] text-muted">{sub}</p>
      )}
    </div>
  );
}
